import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class Job {
    @observable id!: number;

    @observable title!: string;
    @observable metaTitle?: string;
    @observable metaDescription?: string;
    @observable paragraph1?: string;
    @observable paragraph2?: string;
    @observable detailDescription?: string;
    @observable department!: string;
    @observable pearsonURL!: string;
    @observable order!: number;

    constructor(job?: ModelProperties<Job>) {
        if (job) {
            construct(this, job);
        }
    }
}